<div class="flex flex-col relative w-full h-full overflow-hidden">
    <div class="bg-brand-dark px-6 py-4 border-b border-white-08 flex-shrink-0">
        <div class="flex items-center justify-between gap-6 flex-wrap">
            <div class="flex items-center gap-3 min-w-0">
                <div class="header-icon">
                    <span class="material-symbols-outlined text-lg text-accent-purple">request_quote</span>
                </div>
                <div class="min-w-0">
                    <h1 class="m-0 text-base font-semibold text-white leading-tight">{{ 'PAGES.REQUESTS_TITLE' | translate }}</h1>
                    <p class="mt-0.5 mb-0 text-[11px] text-[#9CA3AF] leading-snug truncate">
                        {{ 'PAGES.REQUESTS_DESCRIPTION' | translate }}
                    </p>
                </div>
            </div>

            <div class="flex items-center gap-2 flex-wrap justify-end">
                @if (adminRole() !== 'COMPLIANCE') {
                    <ng-container [formGroup]="rangePickerCSVForm">
                        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="!w-[230px] header-csv-range">
                            <mat-label>{{ 'REQUESTS_PAGE.CSV_DATE_RANGE' | translate }}</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate formControlName="from" [max]="maxCSVDate" [placeholder]="'REQUESTS_PAGE.FROM_DATE' | translate">
                                <input matEndDate formControlName="to" [max]="maxCSVDate" [placeholder]="'REQUESTS_PAGE.TO_DATE' | translate">
                            </mat-date-range-input>
                            @if (rangePickerCSVForm.controls.from.value || rangePickerCSVForm.controls.to.value) {
                                <button mat-icon-button matIconSuffix
                                        (click)="rangePickerCSVForm.controls.from.reset(); rangePickerCSVForm.controls.to.reset();">
                                    <mat-icon>close</mat-icon>
                                </button>
                            }
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>

                            @if (rangePickerCSVForm.controls.from.hasError('matStartDateInvalid') || rangePickerCSVForm.controls.from.hasError('matDatepickerParse')) {
                                <mat-error>{{ 'REQUESTS_PAGE.INVALID_FROM_DATE' | translate }}</mat-error>
                            } @else if (rangePickerCSVForm.controls.to.hasError('matEndDateInvalid') || rangePickerCSVForm.controls.to.hasError('matDatepickerParse')) {
                                <mat-error>{{ 'REQUESTS_PAGE.INVALID_TO_DATE' | translate }}</mat-error>
                            }
                        </mat-form-field>
                    </ng-container>

                    <button [disabled]="rangePickerCSVForm.invalid" mat-icon-button class="!text-white" (click)="downloadCSV()">
                        <mat-icon>sim_card_download</mat-icon>
                    </button>
                }

                <button mat-icon-button class="!text-white" [matMenuTriggerFor]="menu">
                    <mat-icon>settings</mat-icon>
                </button>

                <mat-menu #menu="matMenu" [hasBackdrop]="true">
                    <div class="max-h-[200px] overflow-auto" cdkScrollable>
                        <div cdkDropList class="menu-list bg-white dark:bg-[#424242]" (cdkDropListDropped)="drop($event)">
                            @for (displayedColumn of menuDisplayedColumns; track displayedColumn) {
                                <div class="menu-item bg-white dark:bg-[#424242]" cdkDrag>
                                    <mat-icon class="cursor-move" cdkDragHandle>drag_handle</mat-icon>
                                    <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                                                  [ngModel]="!filteredDisplayedColumns.includes(displayedColumn)"
                                                  (change)="handlerChangeDisplayColumnCheckbox($event, displayedColumn)"></mat-checkbox>
                                    {{ displayedColumn }}
                                </div>
                            }
                        </div>
                    </div>
                </mat-menu>
            </div>
        </div>
    </div>

    <!-- Stage funnel -->
    <div class="bg-white dark:bg-brand-dark-lighter px-4 py-3 border-b border-gray-200 dark:border-white-08">
        <div class="flex items-center gap-0 w-full">
            <!-- All -->
            @if (!isCompliance) {
                <div class="relative flex items-center flex-1">
                    <div (click)="stageFilter.set(null)"
                        [class]="'w-full px-4 py-2 text-xs font-medium whitespace-nowrap rounded-l-lg clip-path-chevron-right-only cursor-pointer transition-all flex items-center justify-center gap-2 ' +
                        (stageFilter() === null
                            ? 'bg-gray-900 dark:bg-gray-900 text-white ring-4 ring-gray-300 dark:ring-gray-700/50 funnel-card-active'
                            : 'bg-gray-700/70 dark:bg-gray-700/70 text-white hover:bg-gray-800 dark:hover:bg-gray-800 hover:shadow-lg')">
                        <span>{{ 'REQUESTS_PAGE.STAGE_ALL' | translate }}</span>
                    </div>
                </div>
            }

            <!-- Not Completed -->
            @if (!isCompliance) {
                <div class="relative flex items-center flex-1">
                    <div (click)="stageFilter.set('NOT_COMPLETED')"
                        [class]="'w-full px-4 py-2 text-xs font-medium whitespace-nowrap clip-path-chevron-right cursor-pointer transition-all flex items-center justify-center gap-2 ' +
                        (stageFilter() === 'NOT_COMPLETED'
                            ? 'bg-gray-600 dark:bg-gray-700 text-white ring-4 ring-gray-300 dark:ring-gray-600/50 funnel-card-active'
                            : 'bg-gray-400/70 dark:bg-gray-500/70 text-white hover:bg-gray-500 dark:hover:bg-gray-600 hover:shadow-lg')">
                        <span>{{ 'REQUESTS_PAGE.STAGE_NOT_COMPLETED' | translate }}</span>
                    </div>
                </div>
            }

            <!-- New -->
            <div class="relative flex items-center flex-1">
                <div (click)="stageFilter.set('NEW')"
                    [class]="'w-full px-4 py-2 text-xs font-medium whitespace-nowrap cursor-pointer transition-all flex items-center justify-center gap-2 ' +
                    (isCompliance ? 'rounded-l-lg clip-path-chevron-right-only ' : 'clip-path-chevron-right ') +
                    (stageFilter() === 'NEW'
                        ? 'bg-blue-900 dark:bg-blue-900 text-white ring-4 ring-blue-300 dark:ring-blue-700/50 funnel-card-active'
                        : 'bg-blue-700/70 dark:bg-blue-700/70 text-white hover:bg-blue-800 dark:hover:bg-blue-800 hover:shadow-lg')">
                    <span>{{ 'REQUESTS_PAGE.STAGE_NEW' | translate }}</span>
                </div>
            </div>

            <!-- Evaluation -->
            <div class="relative flex items-center flex-1">
                <div (click)="stageFilter.set('EVALUATION')"
                    [class]="'w-full px-4 py-2 text-xs font-medium whitespace-nowrap cursor-pointer transition-all flex items-center justify-center gap-2 ' +
                    (isCompliance ? 'rounded-r-lg clip-path-chevron-left-only ' : 'clip-path-chevron-right ') +
                    (stageFilter() === 'EVALUATION'
                        ? 'bg-yellow-500 dark:bg-yellow-800 text-yellow-900 dark:text-yellow-100 ring-4 ring-yellow-300 dark:ring-yellow-600/50 funnel-card-active'
                        : 'bg-yellow-300/70 dark:bg-yellow-600/70 text-yellow-900 dark:text-yellow-100 hover:bg-yellow-400 dark:hover:bg-yellow-700 hover:shadow-lg')">
                    <span>{{ 'REQUESTS_PAGE.STAGE_EVALUATION' | translate }}</span>
                </div>
            </div>

            <!-- Offer -->
            @if (!isCompliance) {
                <div class="relative flex items-center flex-1">
                    <div (click)="stageFilter.set('OFFER')"
                        [class]="'w-full px-4 py-2 text-xs font-medium whitespace-nowrap clip-path-chevron-right cursor-pointer transition-all flex items-center justify-center gap-2 ' +
                        (stageFilter() === 'OFFER'
                            ? 'bg-purple-500 dark:bg-purple-800 text-purple-900 dark:text-purple-100 ring-4 ring-purple-300 dark:ring-purple-600/50 funnel-card-active'
                            : 'bg-purple-300/70 dark:bg-purple-600/70 text-purple-900 dark:text-purple-100 hover:bg-purple-400 dark:hover:bg-purple-700 hover:shadow-lg')">
                        <span>{{ 'REQUESTS_PAGE.STAGE_OFFER' | translate }}</span>
                    </div>
                </div>
            }

            <!-- Invoice -->
            @if (!isCompliance) {
                <div class="relative flex items-center flex-1">
                    <div (click)="stageFilter.set('INVOICE')"
                        [class]="'w-full px-4 py-2 text-xs font-medium whitespace-nowrap clip-path-chevron-right cursor-pointer transition-all flex items-center justify-center gap-2 ' +
                        (stageFilter() === 'INVOICE'
                            ? 'bg-orange-500 dark:bg-orange-800 text-orange-900 dark:text-orange-100 ring-4 ring-orange-300 dark:ring-orange-600/50 funnel-card-active'
                            : 'bg-orange-300/70 dark:bg-orange-600/70 text-orange-900 dark:text-orange-100 hover:bg-orange-400 dark:hover:bg-orange-700 hover:shadow-lg')">
                        <span>{{ 'REQUESTS_PAGE.STAGE_INVOICE' | translate }}</span>
                    </div>
                </div>
            }

            <!-- In work. Split out of Closed by SMC-108: a paying CUSTOMER and the
                 SC investigation ladder all still have somewhere to go, so an
                 operator was reading live cases as finished. Teal is unused
                 elsewhere in the funnel, so it reads as neither Invoice nor Closed. -->
            @if (!isCompliance) {
                <div class="relative flex items-center flex-1">
                    <div (click)="stageFilter.set('IN_WORK')"
                        [class]="'w-full px-4 py-2 text-xs font-medium whitespace-nowrap clip-path-chevron-right cursor-pointer transition-all flex items-center justify-center gap-2 ' +
                        (stageFilter() === 'IN_WORK'
                            ? 'bg-teal-600 dark:bg-teal-900 text-white ring-4 ring-teal-300 dark:ring-teal-700/50 funnel-card-active'
                            : 'bg-teal-400/70 dark:bg-teal-700/70 text-white hover:bg-teal-500 dark:hover:bg-teal-800 hover:shadow-lg')">
                        <span>{{ 'REQUESTS_PAGE.STAGE_IN_WORK' | translate }}</span>
                    </div>
                </div>
            }

            <!-- Closed -->
            @if (!isCompliance) {
                <div class="relative flex items-center flex-1">
                    <div (click)="stageFilter.set('CLOSED')"
                        [class]="'w-full px-4 py-2 text-xs font-medium whitespace-nowrap clip-path-chevron-right cursor-pointer transition-all flex items-center justify-center gap-2 ' +
                        (stageFilter() === 'CLOSED'
                            ? 'bg-green-700 dark:bg-green-900 text-white ring-4 ring-green-300 dark:ring-green-700/50 funnel-card-active'
                            : 'bg-green-500/70 dark:bg-green-700/70 text-white hover:bg-green-600 dark:hover:bg-green-800 hover:shadow-lg')">
                        <span>{{ 'REQUESTS_PAGE.STAGE_CLOSED' | translate }}</span>
                    </div>
                </div>
            }

            <!-- Canceled -->
            @if (!isCompliance) {
                <div class="relative flex items-center flex-1">
                    <div (click)="stageFilter.set('CANCELED')"
                        [class]="'w-full px-4 py-2 text-xs font-medium whitespace-nowrap rounded-r-lg clip-path-chevron-left-only cursor-pointer transition-all flex items-center justify-center gap-2 ' +
                        (stageFilter() === 'CANCELED'
                            ? 'bg-red-700 dark:bg-red-900 text-white ring-4 ring-red-300 dark:ring-red-700/50 funnel-card-active'
                            : 'bg-red-500/70 dark:bg-red-700/70 text-white hover:bg-red-600 dark:hover:bg-red-800 hover:shadow-lg')">
                        <span>{{ 'REQUESTS_PAGE.STAGE_CANCELED' | translate }}</span>
                    </div>
                </div>
            }
        </div>
    </div>

    <!-- Source filter bar -->
    <div class="flex items-center gap-2 w-full px-4 py-2">
        <div (click)="filterSource.set(null)"
            [class]="'px-3 py-1.5 text-xs font-medium rounded-md cursor-pointer transition-all ' +
            (filterSource() === null
                ? 'bg-slate-700 text-white ring-2 ring-slate-400'
                : 'bg-slate-200 text-slate-700 hover:bg-slate-300 dark:bg-slate-700 dark:text-slate-200 dark:hover:bg-slate-600')">
            All Sources
        </div>
        <div (click)="filterSource.set('SAFE_MY_CRYPTO')"
            [class]="'px-3 py-1.5 text-xs font-medium rounded-md cursor-pointer transition-all ' +
            (filterSource() === 'SAFE_MY_CRYPTO'
                ? 'bg-indigo-700 text-white ring-2 ring-indigo-400'
                : 'bg-indigo-100 text-indigo-700 hover:bg-indigo-200 dark:bg-indigo-900/40 dark:text-indigo-200 dark:hover:bg-indigo-900/60')">
            Safe My Crypto
        </div>
        <div (click)="filterSource.set('STAR_COMPLIANCE')"
            [class]="'px-3 py-1.5 text-xs font-medium rounded-md cursor-pointer transition-all ' +
            (filterSource() === 'STAR_COMPLIANCE'
                ? 'bg-teal-700 text-white ring-2 ring-teal-400'
                : 'bg-teal-100 text-teal-700 hover:bg-teal-200 dark:bg-teal-900/40 dark:text-teal-200 dark:hover:bg-teal-900/60')">
            Star Compliance
        </div>
    </div>

    <div class="project-table flex-1 overflow-auto rounded-lg border border-solid border-gray-200 shadow-base relative mb-10">
        <table [dataSource]="dataSource" class="!whitespace-nowrap"
               [ngClass]="{'!h-full': !dataSource.data.length|| !dataSource.filteredData.length}"
               mat-table matSort (matSortChange)="handleSort($event)">
            <ng-container matColumnDef="userId">
                <th *matHeaderCellDef mat-header-cell mat-sort-header class="!pl-5">{{ 'COL.USER_ID' | translate }}</th>
                <td *matCellDef="let element" mat-cell [matTooltip]="element.userId" class="!pl-5"
                    [matTooltipShowDelay]="500">
                    @if (newIds().has(element.id)) {
                        <span class="inline-block bg-emerald-500 text-white text-[10px] px-1.5 py-0.5 rounded-full uppercase font-semibold tracking-wide mr-1.5 align-middle">NEW</span>
                    }
                    {{ (element.userId | cropWithDotsCenter) || '---' }}
                    @if (element.userId) {
                        <app-copy-button [value]="element.userId" size="small"></app-copy-button>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="id">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'COL.CASE' | translate }}</th>
                <td *matCellDef="let element" mat-cell [matTooltip]="element.id" [matTooltipShowDelay]="500">
                    {{ element.caseRef || '---' }}
                    @if (element.id) {
                        <app-copy-button [value]="element.id" size="small"></app-copy-button>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="source">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'COL.SOURCE' | translate }}</th>
                <td *matCellDef="let element" mat-cell>
                    @if (element.source === 'SAFE_MY_CRYPTO') {
                        {{ 'SAFE MY CRYPTO' }}
                    }
                    @else if (element.source === 'STAR_COMPLIANCE') {
                        {{ 'STAR COMPLIANCE' }}
                    } @else {
                        {{ '---' }}
                    }

                </td>
            </ng-container>

            <ng-container matColumnDef="telegramUsername" sticky>
                <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'COL.TELEGRAM_USERNAME' | translate }}</th>
                <td *matCellDef="let element" mat-cell>
                    <app-telegram-user-link (click)="$event.stopPropagation()"
                                            [telegramUsername]="element.telegramUsername"></app-telegram-user-link>
                </td>
            </ng-container>

            <ng-container matColumnDef="country">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'COL.COUNTRY' | translate }}</th>
                <td *matCellDef="let element" mat-cell>
                    {{ element.country ?? '---' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="victimType">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'COL.VICTIMS_TYPE' | translate }}</th>
                <td *matCellDef="let element" mat-cell>
                    {{ element.victimType ?? '---' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="scamTypeId">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'COL.SCAM_TYPE' | translate }}</th>
                <td *matCellDef="let element" mat-cell>
                    {{ element.scamTypeId ?? '---' }}
                </td>
            </ng-container>


            <ng-container matColumnDef="initiatedAt">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'COL.CREATED' | translate }}</th>
                <td *matCellDef="let element" mat-cell>
                    @if (element.initiatedAt) {
                        {{ (element.initiatedAt | date: 'hh:mm a') }}
                        <br>
                        {{ (element.initiatedAt | date: 'dd/MM/yyyy') }}
                    } @else {
                        {{ '---' }}
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="submittedAt">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'COL.SUBMISSION_DATE' | translate }}</th>
                <td *matCellDef="let element" mat-cell>
                    @if (element.submittedAt) {
                        {{ (element.submittedAt | date: 'hh:mm a') }}
                        <br>
                        {{ (element.submittedAt | date: 'dd/MM/yyyy') }}
                    } @else {
                        {{ '---' }}
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="updatedAt">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'COL.CASE_LAST_UPDATE' | translate }}</th>
                <td *matCellDef="let element" mat-cell>
                    @if (element.updatedAt) {
                        {{ (element.updatedAt | date: 'hh:mm a') }}
                        <br>
                        {{ (element.updatedAt | date: 'dd/MM/yyyy') }}
                    } @else {
                        {{ '---' }}
                    }

                </td>
            </ng-container>

            <ng-container matColumnDef="phone">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'COL.PHONE' | translate }}</th>
                <td *matCellDef="let element" mat-cell [matTooltip]="element.phone" [matTooltipShowDelay]="500">
                    <div class="flex items-center gap-1 max-w-[150px]">
                        <span class="truncate">{{ element.phone ?? '---' }}</span>
                        @if (element.phone) {
                            <app-copy-button [value]="element.phone" size="small"></app-copy-button>
                        }
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="email">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'COL.EMAIL' | translate }}</th>
                <td *matCellDef="let element" mat-cell [matTooltip]="element.email" [matTooltipShowDelay]="500">
                    <div class="flex items-center gap-1 max-w-[150px]">
                        <span class="truncate">{{ element.email ?? '---' }}</span>
                        @if (element.email) {
                            <app-copy-button [value]="element.email" size="small"></app-copy-button>
                        }
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="kyc">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'COL.KYC' | translate }}</th>
                <td *matCellDef="let element" mat-cell>
                    {{ element.kyc ?? '---' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="caseAmount">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'COL.CASE_AMOUNT' | translate }}</th>
                <td *matCellDef="let element" mat-cell>
                    <div class="flex items-center gap-1">
                    {{ element.estimatedLosesAmount ?? '---' }}
                    {{ element.estimatedLosesCurrency ?? '---' }}

                    @if (element.nativeCurrencies && (element.nativeCurrencies | keyvalue).length > 0) {
                        <button #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menuAmountTokens" type="button" class="flex min-w-[14px] h-[14px] w-[14px] !p-0 ml-[4px] popover-hover-wrap relative" (click)="$event.stopPropagation()">
                          <mat-icon class="!w-[14px] !h-[14px] !text-[14px] text-aml-green-500/20" svgIcon="tooltip-icon"></mat-icon>
                        </button>
                        <mat-menu class="menu-custom-scroll menu-lea-cases-table !overflow-visible !w-[220px]" #menuAmountTokens="matMenu" [hasBackdrop]="true">
                          <div class="rounded-[7px] py-[5px] px-[10px] w-full bg-white shadow-3 flex flex-col relative">
                            <span class="triangle"></span>
                            @for (network of element.nativeCurrencies | keyvalue; track network.key) {
                              @for (token of asRecord(network.value) | keyvalue; track token.key) {
                                <div class="min-h-[24px] flex items-center justify-between border-b border-solid border-[#E5E5E5] last:border-none">
                                  <span class="text-aml-green-700 text-[12px] leading-[1]">{{network.key}} / {{token.key}}</span>
                                  <span class="text-aml-green-700 text-[12px] leading-[1] font-bold">
                                    {{ token.value || '0.00' }}
                                  </span>
                                </div>
                              }
                            }
                          </div>
                        </mat-menu>
                    }
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="leadStatus">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'COL.CASE_STATUS' | translate }}</th>
                <td *matCellDef="let element" mat-cell>
                    @if (element.leadStatus === 'SUBMITTED') {
                        {{ element.incidentStatus }}
                    } @else {
                        {{ element.leadStatus }}
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="paymentDue">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'COL.PAYMENT_DUE' | translate }}</th>
                <td *matCellDef="let element" mat-cell>
                    {{ element.paymentDueAmount ?? '---' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="totalCost">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'COL.TOTAL_PAID' | translate }}</th>
                <td *matCellDef="let element" mat-cell>
                    @if (element.totalCostAmount) {
                        {{ element.totalCostAmount }}{{ element.totalCostCurrency ? ' ' + element.totalCostCurrency : '' }}
                    } @else {
                        ---
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="numberOfInvoices">
                <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'COL.NUMBER_OF_INVOICES' | translate }}</th>
                <td *matCellDef="let element" mat-cell>
                    {{ element.numberOfInvoices ?? '---' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th *matHeaderCellDef mat-header-cell></th>
                <td *matCellDef="let element" mat-cell (click)="$event.stopPropagation()">
                    @if (element.source === 'SAFE_MY_CRYPTO') {
                        @switch (element.incidentStatus) {
                            @case ('NEW') {
                                <button mat-icon-button [matMenuTriggerFor]="menu">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button type="button" mat-menu-item (click)="cancelCase(element)">Cancel Case</button>
                                </mat-menu>
                            }
                            @case ('OFFER_EXPIRED') {
                                <button mat-icon-button [matMenuTriggerFor]="menu">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button type="button" mat-menu-item (click)="cancelCase(element)">Cancel Case</button>
                                </mat-menu>
                            }
                            @case ('REQUEST_OFFER') {
                                <button mat-icon-button [matMenuTriggerFor]="menu">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button type="button" mat-menu-item (click)="cancelCase(element)">Cancel Case</button>
                                </mat-menu>
                            }
                            @case ('CUSTOMER') {
                                <button mat-icon-button [matMenuTriggerFor]="menu">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button type="button" mat-menu-item (click)="addInvoice(element)">Add invoice</button>
                                    <button type="button" mat-menu-item (click)="toSuccess(element)">To Success</button>
                                </mat-menu>
                            }
                            @case ('SUCCESS') {
                                <button mat-icon-button [matMenuTriggerFor]="menu">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button type="button" mat-menu-item (click)="toDone(element)">To Done</button>
                                </mat-menu>
                            }
                        }
                    }
                    @if (element.source === 'STAR_COMPLIANCE') {
                        <button mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <a [routerLink]="getCaseRoute(element)" mat-menu-item>
                                <mat-icon>visibility</mat-icon>
                                View Details
                            </a>
                        </mat-menu>
                    }
                    
                </td>
            </ng-container>

            <tr *matNoDataRow class="mat-mdc-row mdc-data-table__row !h-[300px]">
                <td [attr.colspan]="displayedColumns.length" class="mat-mdc-cell mdc-data-table__cell"
                    style="text-align: center">
                    <div class="flex justify-center items-center p-4 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                        <img alt="data-empty" height="146" [priority]="true"
                             ngSrc="assets/icons/custom/data-empty.svg"
                             width="227">
                    </div>
                </td>
            </tr>

            <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
            <tr *matRowDef="let row; columns: displayedColumns;"
                class="cursor-pointer hover:!bg-gray-100 dark:hover:!bg-[#5f5f5f]" mat-row
                [routerLink]="getCaseRoute(row)"
                (click)="onRowClick(row)"
                [ngClass]="{
                    'not-viewed': !row.hasOpened,
                    'new-row-flash': newIds().has(row.id)
                }"
            ></tr>
        </table>
    </div>

    <mat-paginator class="mt-auto" [ngClass]="{'!hidden': !dataSource.data.length}"
                   (page)="handlePageEvent($event)"
                   [length]="paginator.length"
                   [pageSize]="paginator.pageSize"
                   [pageSizeOptions]="[25, 50, 100]"
                   [pageIndex]="paginator.pageIndex"
                   aria-label="Select page of periodic elements" color="accent" [showFirstLastButtons]="true">
    </mat-paginator>

    @if (loading()) {
        <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
            <mat-spinner color="accent"></mat-spinner>
        </div>
    }
</div>
